// CustomModal.js
import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from '@material-ui/core';

const CustomModal = ({ open, handleClose, handleOk ,title,description,positiveText='Ok'}:any) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{description}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
         {positiveText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomModal;



// WEBPACK FOOTER //
// ./src/components/CustomModal/index.tsx